import { Component, OnInit, Input } from '@angular/core';
import { Translation } from '@3ddv/ngx-sites-builder-lib';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from '../translation.service';

@Component({
  selector: 'app-translation-text',
  templateUrl: './translation-text.component.html',
  styleUrls: ['./translation-text.component.scss']
})
export class TranslationTextComponent implements OnInit {

  @Input() tool: Translation;
  // Translations text
  public newTranslationText: {section_id: string, translation: string};
  public translationsTextList: Array<{section_id: string, translation: string}>;
  // public translationsTextList: {[section_id: string]: string};
  // public translationsTextList: TranslationItems;

  constructor(private toastrService: ToastrService,
              private translationService: TranslationService) { }

  ngOnInit(): void {
    // Translations new item init
    this.newTranslationText = {section_id: '', translation: ''};
    this.translationsTextList = [];

    //! Test data, delete when it's finished
    // this.tool.customData = {
    //   "S_124": "New nameeeeeeee",
    //   "S_128": "New nameeeeeeee",
    // };
    // !

    // Update custom list: Get customData if exists and set it to list
    if (this.tool.customData) {
      this.translationsTextList = this.transformObjectToArrayData(this.tool.customData);
      // Adds or overwrites customData to tool.data
      this.tool = this.translationService.addCustomData(this.tool);
    }
    
  }
  
  public addNewTranslationText() {
    // Validate translation
    if (this.validateStandardTextField(this.newTranslationText.section_id) && this.validateStandardTextField(this.newTranslationText.translation)) {
      if (this.validateNonDuplicateTranslation(this.newTranslationText)) {
        if (this.tool.customData === null) {
          this.tool.customData = {};
        }
        // Añadir el elemento en la customData y en la tool data (para que se refleje en el resultado)
        this.tool.customData[this.newTranslationText.section_id] = this.newTranslationText.translation;

        // Update custom translations list
        this.translationsTextList = this.transformObjectToArrayData(this.tool.customData);
        // console.log('Translations List: ', this.translationsTextList);
        // Adds or overwrites customData to tool.data
        this.tool = this.translationService.addCustomData(this.tool);
        // console.log('Translations Data: ', this.tool.data);

        // Reset text fields
        this.newTranslationText = {section_id: '', translation: ''};
        this.toastrService.success('Translation text added to list.', 'Translation added!');

      } else {
        this.toastrService.error('This Section Id is already added to Translations List.', 'Duplicate Section Id');
      }
    } else {
      this.toastrService.error('Some fields need to be field.', 'Missing fields');
    }
  }

  public deleteTranslationText(translationItem: {section_id: string, translation: string}) {
    if (this.translationsTextList.includes(translationItem) !== undefined) {
      // Borrar el elemento de la customData y de la tool data (para que se refleje en el resultado)
      if (this.tool.customData[translationItem.section_id]) {
        delete this.tool.customData[translationItem.section_id];
      }
      if (this.tool.data[translationItem.section_id]) {
        if (this.tool.fileData && this.tool.fileData[translationItem.section_id]) {
          this.tool.data[translationItem.section_id] = this.tool.fileData[translationItem.section_id];
        } else {
          delete this.tool.data[translationItem.section_id];
        }
      }

      // Update custom list: Get customData if exists and set it to list
      this.translationsTextList = this.transformObjectToArrayData(this.tool.customData);
      // console.log('Translations List: ', this.translationsTextList);
      
      // Adds or overwrites customData to tool.data
      this.tool = this.translationService.addCustomData(this.tool);
      // console.log('Translations Data: ', this.tool);

      this.toastrService.success('Translation text was deleted from list.', 'Translation deleted');
    } else {
      this.toastrService.error("The action could not be completed.", 'Some error occurred');
    }
  }

  private validateStandardTextField(textField: any): boolean {
    return textField.length > 0 && typeof textField === 'string'? true : false;
  }

  private validateNonDuplicateTranslation(translation: {section_id: string, translation: string}): boolean {
    let condition: boolean = this.translationsTextList.find(trans => trans.section_id === translation.section_id) === undefined;
    // console.log('Duplicate Translation: ', !condition);
    return condition? true : false;
  }
  
  private transformObjectToArrayData(translationsObject: {[section_id: string]: string}) {
    let transArrayData: Array<{section_id: string, translation: string}> = [];
    for (const key in translationsObject) {
      let transItem: {section_id: string, translation: string} = {
        section_id: key,
        translation: translationsObject[key]
      };
      transArrayData.push(transItem);
    }
    // console.log('Translations Data', transArrayData);
    return transArrayData;
  }
  
  // private transformArrayToObjectData(translationsArray: Array<{section_id: string, translation: string}>) {
  //   let transObjectData: {[section_id: string]: string} = {};
  //   for (const trans of translationsArray) {
  //     transObjectData[trans.section_id] = trans.translation;
  //   }
  //   // console.log('Translations Data', transObjectData);
  //   return transObjectData;
  // }

}
